import { LogOnInternalRs } from "../services/GAIN/gainlogonresp";
import { IGroupedRq, HistoricalDataReq } from "../api/DixApiClient";
import { IServiceRequest } from "../interfaces/service.request";
import { HistoryItemPeriod } from "../interfaces/historyItem";
import { TradeRequestModel, EditRq } from "../model/trade.request.data";
import { Ticket } from "../components/tradedeskTabs/orders/tradeskOrdersTab/tradeskOrdersTab.component";
import { IEditRq } from "../interfaces/service.response";

export enum Providers {
    DEMO = "DEMO",
    OANDA = "OANDA",
    TD = "TD",
    GAIN = "GAIN",
    NONE = "NONE"
}

export interface IProvider {
    CloseTrade(Data: Ticket): void;
    EditOrder(Data: EditRq): void;
    CancelOrder(Data: Ticket): void;
    SwitchOff(): void;
    SwitchAccount(Data: any): void;
    LogOn(userName: string, password: string): Promise<LogOnInternalRs>;
    HistoricalData(reqArray: HistoricalDataReq[]): void;
    GetProviderIntervalsInfo(): HistoryItemPeriod[];
    OrderRequest(request: TradeRequestModel): void;
    GetProviderIntervalsInfo(): HistoryItemPeriod[];
}

export class ProviderInfo {
    static providers: any = {};
    IsLocal: boolean = false;
    Provider?: IProvider;

    constructor(isLocal: boolean, providerEnum: Providers) {
        this.IsLocal = isLocal;
        this.Provider = ProviderInfo.providers[providerEnum.toString()];
    }

    static RegisterProvider(providerEnum: Providers, providerObject: IProvider) {
        this.providers[providerEnum.toString()] = providerObject;
    }
}

export function GetProviderInfo(provider: Providers): ProviderInfo {
    switch (provider) {
        case Providers.DEMO:
            return new ProviderInfo(false, provider);
        case Providers.OANDA:
            return new ProviderInfo(false, provider);
        case Providers.TD:
            return new ProviderInfo(false, provider);
        case Providers.GAIN:
            return new ProviderInfo(true, provider);
    }

    return new ProviderInfo(false, provider);
}

export function ProvidersList(): IproviderRowData[] {
    let list: IproviderRowData[] = [
        {
            id: Providers.DEMO,
            label: "SimpleTrader",
            logoUrl: "images/providers/demo-logo.png?v=2",
            iconUrl: ""
        },
        {
            id: Providers.OANDA,
            label: "OANDA",
            logoUrl: "images/providers/oanda-logo.png",
            logoUrl_W: "images/providers/wbg/oanda.png",
            iconUrl: "images/providers/oanda-con.png",
            openAccountUrl:
                "https://fxtrade.oanda.com/your_account/fxtrade/register/individual/beforeyoubegin?ib=1507134",
            withDrawalUrl: "https://www.oanda.com/account/"
        },
        {
            id: Providers.GAIN,
            label: "GAIN",
            logoUrl: "images/providers/gain-capital-logo.png",
            logoUrl_W: "images/providers/wbg/gain.png",
            iconUrl: "images/providers/gain-con.png",
            openAccountUrl: "https://application.forex.com/en/step/1?ibcode=AMRO&subibcode=PTWI",
            withDrawalUrl: "https://www.gaincapital.com/login.shtml"
        }
        //  { "id": Providers.TD, "label": "AMERITRADE" },
    ];
    return list;
}

export interface IproviderRowData {
    id: Providers;
    label: string;
    logoUrl?: string;
    logoUrl_W?: string;
    iconUrl?: string;
    openAccountUrl?: string;
    withDrawalUrl?: string;
}
